import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PayrollRequest } from 'src/app/models/payroll.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HumanResourcesService } from 'src/app/services/human-resources.service';
import { PayrollService } from 'src/app/services/payroll.service';
import { WarehouseService } from 'src/app/services/warehouse.service';

@Component({
  selector: 'app-payroll',
  templateUrl: './payroll.component.html',
  styleUrls: ['./payroll.component.scss']
})
export class PayrollComponent implements OnInit {
  areas = [];
  departments = [];
  positions = [];
  warehouses = [];
  numberOfEmployees = 0;
  typeContract = 4;
  startDate = "2024-02-01";
  month = "";
  summary = null;
  dropDown: { [key: number]: boolean } = {};
  totalAll = 0;
  newPayroll: PayrollRequest = new PayrollRequest();
  generating = false;
  saving = false;

  constructor(
    private warehouseService: WarehouseService,
    private rrhh: HumanResourcesService,
    private toastService: ToastrService,
    private payrollService: PayrollService
  ) {

  }

  ngOnInit(): void {
    this.getAllAreas();
    this.getAllDepartments();
    this.getAllPositions();
    this.getWarehouses();
    this.getNumberEmployees();
  }

  getNumberEmployees(){
    this.rrhh.getPaymentContractCompany(this.newPayroll.paymentPeriod).subscribe({
      next: (response: ResponseObject) => {
        this.numberOfEmployees = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getWarehouses() {
    this.warehouseService.getWarehouses().subscribe
      (
        {
          next: (response: ResponseObject) => {
            this.warehouses = response.data;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
          }
        }
      )
  }

  getAllAreas() {
    this.rrhh.getAllAreas().subscribe
      (
        {
          next: (response: ResponseObject) => {
            this.areas = response.data;
            console.log(this.areas);
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
          }
        }
      )
  }

  getAllDepartments() {
    this.rrhh.getAllDepartments().subscribe
      (
        {
          next: (response: ResponseObject) => {
            this.departments = response.data;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
          }
        }
      )
  }

  getAllPositions() {
    this.rrhh.getAllPositions().subscribe
      (
        {
          next: (response: ResponseObject) => {
            this.positions = response.data;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
          }
        }
      )
  }

  getSummary() {
    this.generating = true;
    this.payrollService.getSummaryContract(this.departments[0].id, this.newPayroll.paymentPeriod, new Date(this.newPayroll.date).getTime(), new Date(this.newPayroll.endDate).getTime()).subscribe
      (
        {
          next: (response: ResponseObject) => {
            this.summary = response.data;
            this.setNewTotal();
            this.generating = false;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
            this.generating = false;
          }
        }
      )
  }

  getAccepted(position) {
    var accepted = 0;
    position.personal.forEach(element => {
      accepted += element.accepted;
    });
    return accepted;
  }

  getAcceptedTotal(position) {
    var total = 0;
    position.personal.forEach(element => {
      total += (element.accepted) ? element.total : 0;
    });
    position.total = total;
    this.setNewTotal();
    return total;
  }

  setNewTotal() {
    this.totalAll = 0;
    this.summary.forEach(element => {
      this.totalAll += element.total;
    });
  }

  saveGeneratedPayroll(){
    this.saving = true;
    this.newPayroll.payments = this.summary;
    this.newPayroll.period = new Date(this.month).toISOString();
    this.payrollService.generatePayroll(this.newPayroll).subscribe
    (
      {
        next: (response: ResponseObject) => {
          this.summary = response.data;
          this.setNewTotal();
          this.saving = false;
          this.reset();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
          this.saving = false;
          this.reset();
        }
      }
    )
  }

  reset(){
    this.summary = null;
    this.newPayroll = new PayrollRequest();
    this.month = "";
  }
}
